import React, { Component } from "react";
import StackedBarChart from "components/charts/StackedBarChart";
import "./Outcome.css"


class Outcome extends Component {
  	constructor(props) {
		super(props);
		this.state = {
		}
  	}

	addPropsToSeries(series) {
		let colors = ["#DE3E40","#6AA4DC","#FFB607"];
		return (series.map((el,i) => ({
			...el,
			"data": el["data"].map((item) => ({
				...item,
				"y": Math.round((((item["y"]*100)/item["weight"]) + Number.EPSILON) * 100)/100
			})),
			"color": colors[i],
			"borderColor": colors[i],
		})));
	}

	render() {
		return (
			<div className="graph-wrapper screen-right-graph-container">
				<div className="graph-title-container" style={{paddingBottom: "65px"}}>
					<div className="graph-title">Regional Outcome</div>
				</div>
				<div className="graph-screen graph-screen1">
				{this.props.outcomeData ?
					<StackedBarChart
						containerId="stackChart"
						stacking="percent"
						remainingOptions={{
							chart: {
								animation: false,
								type: 'bar',
								backgroundColor: 'transparent',
								height: 710,
								width: 800,
								spacingTop: 15,
							},
							series: this.addPropsToSeries(this.props.outcomeData),
							xAxis: {
								categories: ["American Indian", "Hispanic", "Asian and Pacific Islander", "African American", "Two or More Races", "White"],
								title: {
									text: null
								},
								labels: {
									style: {
										color: "#fff",
										font: "normal normal normal 18px Arial"
									}
								}
							},
							yAxis: {
								title: {
									text: "Education Attainment and Personal Income",
									style: {
										color: "#fff",
										font: "normal normal normal 18px Arial"
									}
								},
								labels: {
									overflow: 'justify',
									style: {
										color: "#fff",
										font: "normal normal normal 18px Arial"
									},
									format: '{value}%'
								},
								tickInterval: 20,
								reversedStacks: false,
								gridLineWidth: 0.5
							},
						}}
					/> : "No data available" }
					</div>
			</div>
		);
	}
}


export default Outcome;